module.exports = __webpack_public_path__ + "img/3.41fe7c61.png";